import lfRequest from '@/service/index'

export function getListData(url: string, queryInfo: any) {
  return lfRequest.get<any>({
    url: url,
    params: queryInfo
  })
}

export function getPageListData(url: string, queryInfo: any, type?: any) {
  return lfRequest.get<any>({
    url: url,
    params: queryInfo,
    responseType: type
  })
}

export function getPostPageListData(url: string, queryInfo: any, type?: any) {
  return lfRequest.post<any>({
    url: url,
    data: queryInfo,
    responseType: type
  })
}

export function deletePageData(url: string) {
  return lfRequest.delete<any>({
    url: url
  })
}

export function createPageData(url: string, newData: any, config?: any) {
  return lfRequest.post<any>({
    url: url,
    data: newData
  })
}

export function createData(url: string, addData: any) {
  return lfRequest.post<any>({
    url: url,
    data: addData
  })
}

export function editPageData(url: string, editData: any) {
  return lfRequest.put<any>({
    url: url,
    data: editData
  })
}

export function queryStatistical(url: string, queryInfo: any) {
  return lfRequest.get<any>({
    url: url,
    params: queryInfo
  })
}

export function downloadData(url: string, queryInfo: any, type?: any) {
  return lfRequest.get<any>({
    url: url,
    params: queryInfo,
    responseType: type
  })
}

export function downloadDataByPost(url: string, queryInfo: any, type?: any) {
  return lfRequest.post<any>({
    url: url,
    data: queryInfo,
    responseType: type
  })
}

export function postData(url: string, queryInfo: any) {
  return lfRequest.post<any>({
    url: url,
    params: queryInfo
  })
}

export function notifyMe(title: string, body: string) {
  if (Notification.permission !== 'granted') {
    Notification.requestPermission().then((permission) => {
      // 检查用户是否同意接收通知
      if (permission !== 'granted') {
        console.log('用户拒绝了通知权限')
      } else {
        const notification = new Notification(title, {
          body: body,
          icon: 'https://jstd-auxi.oss-cn-hangzhou.aliyuncs.com/auxi/2024-08-26/3644398364271.png'
        })

        notification.onclick = function() {
          // 聚焦当前窗口
          window.focus()
        }
      }
    })
  } else {
    const notification = new Notification(title, {
      body: body,
      icon: 'https://jstd-auxi.oss-cn-hangzhou.aliyuncs.com/auxi/2024-08-26/3644398364271.png'
    })

    notification.onclick = function() {
      // 聚焦当前窗口
      window.focus()
    }
  }
}
